import { MouseEvent, useState } from 'react';

const useTabsMenu = () => {

  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLSpanElement | null>(null);

  const handleMenuOpen = (event: MouseEvent<HTMLSpanElement>) => setMenuAnchorEl(event.currentTarget);
  const handleMenuClose = () => setMenuAnchorEl(null);

  return {
    menuAnchorEl,
    handleMenuOpen,
    handleMenuClose
  };
}

export default useTabsMenu;